module.exports = __webpack_public_path__ + "static/img/20250320003.8717453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320003.jpg
// module id = hrpc
// module chunks = 0